export enum ConsentGeneralEvent {
  AcceptAll = 'accept-all',
  RejectAll = 'reject-all',
  ManageOptions = 'manageOptions'
}
